<template>
    <div id="device-gantt" >
        <div  style="padding:0px 10px;background:#fff">
            <el-row class='tab'>
                <div class="user-list">
                    <div>
                        <el-row style="margin-left:10px;margin-top:6px">
                            <el-col :span="20" >
                                <el-input placeholder="设备编码查询" v-model="webSearchStr" class="input-with-select" clearable>
                                    <el-button slot="append" icon="el-icon-search" @click="filterDevice"></el-button>
                                </el-input>
                            </el-col>
                        </el-row>
                        <el-scrollbar style="height:700px">
                            <el-tree ref="tree"  :props="defaultProps" default-expand-all :data="data" node-key="id"   show-checkbox @check="handleCheckChange"></el-tree>
                        </el-scrollbar>
                    </div>
                </div>
                <div class="gantt-list">
                    <div class="tab-head">
                        <div class="table_searchbar">
                            <el-row :gutter="W?20:0">
                                <el-col :span="W?8:10" style="display:flex">
                                    <div class="" >
                                        <span class="title">日期查询：</span>
                                        <el-date-picker @change="selectData" :picker-options="pickerBeginDateBefore" class="y_timeWidth" style="width:230px" v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                                    </div>
                                </el-col>
                                <el-col :span='7'>
                                    <div>
                                        <span class="title">批次号：</span>
                                         
                                        <el-select style="max-width:180px" :loading="loading"  :remote-method="remoteMethod"  remote filterable clearable  v-model='searchForm.splitId' size='small' maxlength='16' placeholder='批次号'
                                              popper-class='width180'>
                                            <el-option v-for="item in batchList" :key="item.key" :value="item.key" :label="item.label"></el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :span="W?9:7" >
                                    <div style="text-align:right">
                                        <el-button icon="el-icon-search" size='mini' type="primary" @click="search">查询</el-button>
                                        <el-button icon="el-icon-refresh" size='mini'  @click="clearSearch">重置</el-button>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="right-item">
                            <div class="explain">
                                <div class="explain-item">
                                    <div style="background:rgb(222,0,0)"></div>
                                    <span>时间冲突</span>
                                </div>
                            </div>
                            <div class="scale-select">
                                <i class="el-icon-arrow-left" @click="prev" style="font-size: 18px;padding: 4px 10px;cursor: pointer;"></i>
                                <div :style="activeIndex==0?{background:'#409EFF',color:'#fff'}:{}" @click="scaleChange(0)">日</div>
                                <div :style="activeIndex==1?{background:'#409EFF',color:'#fff'}:{}" @click="scaleChange(1)">周</div>
                                <div class="border-ringht" :style="activeIndex==2?{background:'#409EFF',color:'#fff'}:{}" @click="scaleChange(2)">15天</div>
                                <i class="el-icon-arrow-right" @click="next" style="font-size: 18px;padding: 4px 10px;cursor: pointer;"></i>
                            </div>
                        </div>
                    </div>

                    
                    <div style="overflow: hidden;">
                        <div class="table-head ">
                            <div class="item border" style="border-right:none">
                                <span>设备编码</span>
                            </div>
                            <div class="item border" style="width:140px;border-right:none">
                                <span>设备名称</span>
                            </div>
                            <div  class="table-time-warp border" :style="{width:`${maxWeight}px`,}">
                                <div v-for="(item,index) in monthDay" :key='index' :style="{flex:item.dayList.length}">
                                    <div style="text-align: center;line-height:37px;text-align: center;border-right:1px solid rgb(220,223,230) ">
                                        <span>{{item.month|filterMonth(dayLen,showHours)}}</span>
                                    </div>
                                    <div style="display:flex">
                                        <div v-for="(dayItem,index1) in item.dayList" :key="dayItem" class="border day-item" :style="index1==0&&index==0?{borderLeft:'none'}:{}">
                                            <span>{{dayItem|filterDay(dayLen,showHours)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div class="scrollbar">
                            <div class="table-body " :style="{width:`${maxWeight+240}px`,height:`${baseHeight*selectDeviceList.length}px`}">
                                <div class="devcie-info">
                                    <div v-for="item in selectDeviceList" :key="item.id" style="display:flex;height:74px" class="device-item">
                                        <div class="item border" style="border-right: none;border-top: none;">
                                            <span>{{item.deviceCode}}</span>
                                        </div>
                                        <div style="display:flex;width:140px;border-right: none;border-top: none;box-sizing: border-box;" class="border">
                                            <span style="width:100px;text-align: center;line-height: 74px;">{{item.deviceName}}</span>
                                            <div style="width:37px;box-sizing: border-box;">
                                                <span class="plan-text border" >计划</span>
                                                <span class="plan-text border">实际</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :style="{width:`${maxWeight}px`,height:`${baseHeight*selectDeviceList.length}px`,}" class="bar-warp">
                                    <div v-for="(item,tIndex) in taskList" :key="tIndex" @click="showLink(item)" class="bar" :style="{width:`${item.w}px`,height:`${item.h}px`,left:`${item.x}px`,top:`${item.y}px`,zIndex:item.zIndex,background:item.color}">
                                        <el-popover placement="top" :offset="item.x" width="500" trigger="click">
                                            <el-row>
                                                <el-col>
                                                    <span class="label" >订单号：</span>
                                                    <span class="value" >{{item.orderCode}} </span>

                                                    <span class="label" >物料编码：</span>
                                                    <span class="value" style="width:150px">{{item.materialCode}} </span>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <span class="label" >工单号：</span>
                                                    <span class="value" >{{item.productionBatchCode}} </span>

                                                    <span class="label" >物料名称：</span>
                                                    <span class="value" style="width:150px">{{item.materialName}} </span>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <span class="label" >工序：</span>
                                                    <span class="value" >{{item.procedureName}} </span>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <span class="label" >计划数量：</span>
                                                    <span class="value" >{{item.amount}} </span>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <span class="label" >计划时间：</span>
                                                    <span class="value" style="width:300px">{{item.planTime}} </span>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <span class="label" >实际时间：</span>
                                                    <span class="value" style="width:300px">{{item.actualTime}} </span>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <span class="label" >进度：</span>
                                                    <span class="value" >{{item.processRatio}} %</span>
                                                </el-col>
                                            </el-row>
                                            <div slot="reference" style="width:100%;height:100%"></div>
                                        </el-popover>
                                    </div>
                                    <div v-for="item in linkList" :style="{width:`${item.w}px`,left:`${item.x}px`,top:`${item.y}px`,transform: `rotate(${item.r}deg)`}" class="link" :key="item.procedureIndex"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>

export default {
    name: "DeviceGantt",
    data() {
        return {
            showHours:false,
            minDate:'',
            maxDate:'',
            pickerBeginDateBefore:{
                onPick:({maxDate,minDate})=>{
                    log(maxDate,minDate,this.dateRange,666)
                    this.minDate=minDate;
                    this.maxDate=maxDate;
                },
                disabledDate:time=> {
                    if(this.minDate){
                        return time.getTime() > this.minDate.getTime() + 14*60*60*24*1000
                    }else{
                        return false
                    }
                }
            },
            activeIndex:2,
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            data:[],
            dateRange:[],
            allWorkerSelect:[],
            taskList:[],
            selectDeviceList:[],
            dayLen:7,
            monthDay:[
                {
                   dayList:[],
                   month:'', 
                }
            ],
            batchList:[],
            splitId:null,
            orderOptions:[],
            colorList1:['rgb(90,225,255)', 'rgb(177,237,241)','rgb(224,242,216)','rgb(255,235,177)'],
            colorList2:['rgb(64,158,255)', 'rgb(0,197,210)','rgb(154,214,129)','rgb(255,190,0)'],
            startTime:'2020-09-25',
            endTime:'2020-10-08',
            baseHeight:74,   //设置每个单个表格高度
            maxWeight:1160,   //设备最大宽度
            deviceUserInfo:[
                // 订单号，工单号，物料编码，物料名称 工序 计划时间 实际时间 数量 进度       
            ],
            deviceUserInfoCopy:[],
            linkList:[],
            loading:false,
            userList:[],
            deviceList:[],
            webSearchStr:'',
            searchForm:{
                deviceName:'',
            },
            checkList:[],
            week:{0:'日', 1:'一', 2:'二', 3:'三', 4:'四', 5:'五', 6:'六', },
            tasks: {
                data: []
            },
            tableTotalPage:0,
            tableCurrentPage:1,
            fristLoad:false,
            tableData:[],
            now : new Date(),
            page: {
                isShow: true,
                total: 0,
                currentPage: 1,
                pageSize: 10,
            },
            dataCopy:[],
            W:false,
            // dateRange: [new Date(this.startTime), new Date(this.endTime)],
            permission:JSON.parse(localStorage.getItem("permission"))
        };
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    filters:{
        filterMonth(str,len,showHours){
           if(len>3&&!showHours){
               let [y,m]= str.split('-')
                y = (''+y).slice(2)
                return y+'年'+Number.parseInt(m) + '月'
           }else{
               return str
           }
        },

        filterDay(str,len,showHours){
            if(len>3&&!showHours){
                str = str.split('-')[2] 
                return Number.parseInt(str)+'日'
            }else{
                return str
            }
        },
    },
    beforeDestroy(){
       
    },
    mounted: async function() {
        window.status=1
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        
        let now = new Date()
        this.startTime = commonUtils.timestampToDate(now-15*24*60*60*1000,true)
        this.endTime = commonUtils.timestampToDate(now,true)
        let {len,monthDay,showHours} = commonUtils.getMonthDay(this.startTime,this.endTime) 
        this.showHours = showHours
        this.dayLen = len
        this.monthDay = monthDay
        
        await this.loadDeviceTree()
        this.dataCopy = commonUtils.cloneObj(this.data)
        setTimeout(async ()=>{
            this.$refs.tree.setCheckedKeys([this.data[0].id])
            let checkList = this.$refs.tree.getCheckedKeys()
            
            if(checkList.length>51){
                checkList.shift()
                checkList.length = 50
                this.$refs.tree.setCheckedKeys(checkList)
            }
            this.checkList = checkList
            this.search()
            await this.loadBatchList()
        },0)
        
    },
    methods: {
        filterDevice(){
            let data = []
            let selectList = []
            let subIdList = []
            this.dataCopy.forEach(item=>{
                let children= item.children.filter(sub=>sub.label.toLowerCase().includes(this.webSearchStr.toLowerCase()))
                if(children.length>0){
                    let json = commonUtils.cloneObj(item)
                    json.children = children
                    data.push(json)
                    children.forEach(c=>{
                        subIdList.push(c.id)
                    })
                    
                    selectList.push(item.id)
                }
                
            })
            this.data = data
            setTimeout(()=>{
                this.$refs.tree.setCheckedKeys(selectList)
                this.checkList = this.$refs.tree.getCheckedKeys().filter(item=>subIdList.includes(item))
                if(this.checkList.length>50){
                    this.checkList.length = 50
                    this.$message.warning('最多可选择50条设备,请优化查询条件')
                    this.$refs.tree.setCheckedKeys(this.checkList)
                }
                this.search()
            },0)
            
        },
        async loadBatchList(productionBatchCode){
            let {data} = await this.$RequestUtil.getAsync({ url: '/api/select/listSplitCode',  params: {  productionBatchCode}, })
            this.batchList =  data
        },

        selectData(e){
            this.minDate = ''
            this.maxDate = ''
        },

        scaleChange(index){
            log(this.activeIndex,index,666)
            let start = 0
            let end = 0
            if(this.activeIndex>index){
                end = this.dateTotimestamp(this.endTime)
                 if(index==0){
                    start = end - 24*60*60*1000
                }else if(index==1){
                    start = end - 6*24*60*60*1000
                }else if(index==2){
                    start = end - 14*24*60*60*1000
                }
                this.startTime = commonUtils.timestampToDate(start,true)
            }else{
                start = this.dateTotimestamp(this.startTime)
                if(index==0){
                    end = start + 24*60*60*1000
                }else if(index==1){
                    end = start + 6*24*60*60*1000
                }else if(index==2){
                    end = start + 14*24*60*60*1000
                }
                this.endTime = commonUtils.timestampToDate(end,true)
            }
            this.activeIndex = index
            
            this.dateRange = [this.startTime,this.endTime]
            this.search()
        },

        prev(){
            let start = this.dateTotimestamp(this.startTime)
            let end = this.dateTotimestamp(this.endTime)
            let temp = 0
            if(this.activeIndex==0){
                temp  = 1*24*60*60*1000
            }else if(this.activeIndex==1){
                temp  = + 6*24*60*60*1000
            }else if(this.activeIndex==2){
                temp  = + 14*24*60*60*1000
            }
            this.startTime = commonUtils.timestampToDate(start-temp,true)
            this.endTime = commonUtils.timestampToDate(end-temp,true)
            this.dateRange = [this.startTime,this.endTime]
            this.search()
        },

        next(){
            let start = this.dateTotimestamp(this.startTime)
            let end = this.dateTotimestamp(this.endTime)
            let temp = 0
            if(this.activeIndex==0){
                temp  = 1*24*60*60*1000
            }else if(this.activeIndex==1){
                temp  = + 6*24*60*60*1000
            }else if(this.activeIndex==2){
                temp  = + 14*24*60*60*1000
            }
            this.startTime = commonUtils.timestampToDate(start+temp,true)
            this.endTime = commonUtils.timestampToDate(end+temp,true)
            this.dateRange = [this.startTime,this.endTime]
            this.search()
        },

        selectTimeChange(){
            let {len,monthDay,showHours} = commonUtils.getMonthDay(this.startTime,this.endTime) 
            this.dayLen = len
            this.showHours = showHours
            this.monthDay = monthDay
            this.computedBarPostion()
        },

        handleCheckChange(ev){
            setTimeout(()=>{
                let list = this.$refs.tree.getCheckedKeys()
                if(list.length>51){
                    list.shift()
                    list.length = 51
                    this.$message.warning('最多可选择50条设备,请优化查询条件')
                    this.$refs.tree.setCheckedKeys(list)
                }
                this.checkList = list
                this.search()
            },0)
            
        },

        computedBarPostion(){
            let selectDeviceList =  this.deviceUserInfo.map(item=>{
                return {
                    deviceCode:item.deviceCode,
                    deviceName:item.deviceName,
                    id:item.id
                }
            })
            this.selectDeviceList = selectDeviceList
            
            let taskList = []
            let count1 = 0
            let count2 = 0
            this.deviceUserInfo.forEach((item,index)=>{
                item.taskInfo.forEach(t=>{
                    let h = 18
                    let y = index*this.baseHeight + 15
                    let color = ''
                    let zIndex = 99
                    if(t.type==2){
                        h = 26
                        y = index*this.baseHeight + 40
                        color = this.colorList2[count2%this.colorList2.length]
                        count2++
                    }else{
                        if(t.hasConflicts){
                            color = 'rgba(222,0,0,0.5)'
                            zIndex = 199
                        }else{
                            color = this.colorList1[count1%this.colorList1.length]
                            count1++
                        }
                    }
                    let w = (this.dateTotimestamp(t.endTime) - this.dateTotimestamp(t.startTime)) * this.maxWeight/(this.dateTotimestamp(this.endTime)+24*60*60*1000 - this.dateTotimestamp(this.startTime))
                    let x = (this.dateTotimestamp(t.startTime) - this.dateTotimestamp(this.startTime))*this.maxWeight/(this.dateTotimestamp(this.endTime)+24*60*60*1000 - this.dateTotimestamp(this.startTime))
                    let x1 = w+x
                    let y1 = y
                    taskList.push({
                        ...t,
                        x:Number.parseInt(x),
                        y:Number.parseInt(y),
                        h:Number.parseInt(h),
                        w:Number.parseInt(w),
                        x1:Number.parseInt(x1),
                        y1:Number.parseInt(y1),
                        color,
                        zIndex,
                    })
                })
                
            })
            this.taskList = taskList
        },

        //计算关联点
        computedBarlink(splitId){
            //最终生成连接线所需数据 坐标（x,y）宽度y 旋转角度r 
            //1.查找相同订单所有工序并排序
            let list = this.taskList.filter(item=>item.splitId==splitId&&item.type==1).sort((item1,item2)=>item1.procedureIndex-item2.procedureIndex)

            //2.根据过滤的list相邻的两个点生成坐标点数据
            let arr = []
            list.forEach((item,index)=>{
                if(index==0){
                    arr.push([[item.x1,item.y1+9]])
                }else{
                    arr[index-1][1] = [item.x,item.y+9]
                    if(index!=list.length-1){
                        arr[index] = [[item.x1,item.y1+9]]
                    }
                    
                }
            })

            //3. 将组边数据转换成线 长度 w  和旋转角度数据
            let linkList = []
            arr.forEach(item=>{
                let [[x,y],[x1,y1]] = item
                let a = Number.parseInt(x1 - x) 
                let b =  Number.parseInt(y1 - y)
                let w = Number.parseInt(Math.pow((a*a + b*b),0.5))
                let r = 0
                if(b==0){
                    if(a>0){
                        r = 0
                    }else{
                        r = -180
                    }
                }else{
                    if(a>0){
                        r = 90 - Number.parseInt(Math.atan(a/b) / (Math.PI / 180))
                    }else{
                        r = -90 - Number.parseInt(Math.atan(a/b) / (Math.PI / 180))
                    }
                }
                linkList.push({x,y,w,r})
            })
            this.linkList = linkList
        },

        showLink(item){
            if(item.splitId){
                this.computedBarlink(item.splitId)
            }else{
                this.linkList = []
            }
        },

        dateTotimestamp(timeStr){
            if(timeStr.length<12){
                timeStr = timeStr.trim() + ' 00:00:00'
            }
            return new Date(timeStr).getTime()
        },

        
     
        async remoteMethod(query){
            this.loading = true;
            await this.loadBatchList(query)
			this.loading = false
        },
        

        async loadDeviceTree(searchText){
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listDeviceGanttSelect',params: {searchText,limitCount:50},});
			if(res.code == 0){
				this.data = res.data;
			}
        },
        
        clearSearch() {
            let form = this.searchForm;
            this.dateRange = []
            form.splitId = null
        },
      
        search:function(){
            if(this.dateRange&&this.dateRange.length == 2){
                this.startTime = this.dateRange[0]
                this.endTime = this.dateRange[1]
            }else if(this.dateRange&&this.dateRange.length == 0&&this.startTime){
                this.dateRange = [this.startTime,this.endTime]
            }else{
                this.dateRange = [this.startTime,this.endTime]
            }
            
            this.$RequestUtil.post({
                url:'/api/Gantt/getDeviceGantt',
                type:'sync',
                params: {
                    deviceList:this.checkList,
                    startTime:this.startTime,
                    endTime:this.endTime,
                    splitId:this.searchForm.splitId
                },
                success: (res) => {
                    if(res.code == 0){
                        this.deviceUserInfo = res.data
                        this.deviceUserInfoCopy = commonUtils.cloneObj(this.deviceUserInfo)
                        this.selectTimeChange()
                        this.linkList = []
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            });
        },

        
    },
    activated(){
    
    }

};
</script>

<style scoped>
    .scrollbar{
        max-height: 592px;
        overflow: hidden;
        overflow-y: auto;
    }
    .scrollbar::-webkit-scrollbar { 
        width:6px; 
        height:2px; 
        background:#ccc; 
        border-radius:10px;/*外层轨道*/
    }
    .scrollbar::-webkit-scrollbar-thumb{ /*内层轨道*/
        display:block; 
        width:4px; 
        margin:0 auto; 
        border-radius: 10px; 
        background:rgba(255, 192, 66, 0.5);
    }
    .bar-warp{
        position: relative;
        overflow: hidden;
    }
    .bar{
        position:absolute;
        border-radius: 6px;
        cursor: pointer;
    }
    .link{
        position:absolute;
        height: 1px;
        z-index: 999;
        transform-origin: 0 0;
        background: red;
    }
    .label {
        display: inline-block;

        height: 32px;
        line-height: 32px;
        font-size: 12px;
        color: #606266;

    }

    .value {
        display: inline-block;
        width: 200px;
        /* height: 32px; */
        line-height: 32px;
        font-size: 12px;
        color: #606266;
        vertical-align: top;
    }
    .border{
        border: 1px solid rgb(220,223,230);
    }
    .item{
        height: 74px;
        text-align: center;
        width:100px;
        line-height: 74px;
        box-sizing: border-box;
        font-size: 12px;
        color: #909399;
        font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC","Microsoft YaHei";
    }
    
    .plan-text{
        display: inline-block;
        width: 40px;
        height: 37px;
        line-height: 37px;
        box-sizing: border-box;
        border-top: none;
        font-size: 12px;
        color: #909399;
        text-align: center;
        font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC","Microsoft YaHei";
    }
    .day-item{
        flex:1;
        line-height:37px;
        text-align: center;
        border-right:none;
        border-bottom: none;
        box-sizing: border-box;
        position: relative;
    }
    .day-item::after {
        content: "";
        position: absolute; 
        top: 36px;
        right: -1px;
        width:1px;
        height:5900px;
        background: rgb(220,223,230);
    }
    .device-item{
        position: relative;
        font-size: 12px;
        color: #909399;
        font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC","Microsoft YaHei";
    }
    .device-item::after{
        content: "";
        position: absolute; 
        top: 73px;
        left: 240px;
        width:1160px;
        height:1px;
        background: rgb(220,223,230);
        
    }
    .table-head{
        display: flex;
    }

    .table-time-warp{
        display: flex;
        height: 74px;
        box-sizing: border-box;
        font-size: 12px;
        color: #909399;
        font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC","Microsoft YaHei";
    }

    .table-body{
        display: flex;
        overflow: hidden;
    }
    .devcie-info {
        width: 240px;
    }
    .tab-head{
        width: 100%;
        /* border: 1px solid #ccc;
        display:flex;
        height: 66px;
        line-height: 66px;
        box-sizing: border-box;
        border-bottom: none; */
    }

    .tab{
        display:flex
    }

    .user-list{
        width:210px;
        margin-right:20px;
        position: relative;
        padding: 10px 0px;
    }
    .user-list::after{
        content: "";
        position: absolute; 
        top: 0px;
        right: -4px;
        width:18px;
        height:106%;
        background: #f6f7fa;
        
    }

    .gantt-list{
        /* border-right: 1px solid  rgb(220,223,230);
        border-bottom: 1px solid  rgb(220,223,230); */
    }
    .left-item{
        width: 230px;
        border-right: 1px solid#ccc;
        box-sizing: border-box;
        text-align: center;
    }
    .right-item{
        display: flex;
        align-items: center;
        margin: 12px 0;
        justify-content: flex-end;
    }
    .scale-select{
        margin-left: 40px;
        width: 244px;
        height: 26px;
        display: flex;
        
       
    }
    .scale-select div{
        flex: 1;
        text-align: center;
        line-height: 26px;
        border: 1px solid #ccc;
        border-right: none;
        cursor: pointer;
        font-size: 14px;
    }
    .scale-select .border-ringht{
        border-right: 1px solid #ccc;
    }

    .explain{
        margin-left: 60px;
        line-height: 100%;
        display: flex;
    }
    .explain .explain-item{
        display: flex;
        margin-right: 40px;
    }
    .explain .explain-item div{
        width: 34px;
        height: 20px;
    }
    .explain .explain-item span{
        margin-left: 12px;
        font-size: 12px;
        line-height: 20px;
    }
    .select-box{
        margin-left: 200px
    }




    .top{
        width: 100%;
        height: 50px;
        background: #ffff;
        margin-top: 0px;
        padding-top: 15px;
    }
    .tabs{
        padding: 5px 20px;
        
    }

    .table_searchbar{
        padding: 15px 20px 0px 20px;
    }
    .content{
        /* width: 102.6%; */
        height: auto;
        margin-top: 20px;
        display: flex;
    }

    .workOrder-deviceTop{
        flex: 1;
        background: #fff;
        padding: 0 20px;
    }

    .summary span{
        font-size: 14px;
        margin-right: 20px;
    }
    #device-gantt{
        overflow: hidden;
        overflow-y: auto;
        width: 102.6%;
        scrollbar-width: none;
       
        margin-left: -20px;
        margin-top:-20px;
        /* background: #f6f7fa; */
        height: 102.5%;
    }
    #device-gantt::-webkit-scrollbar {
        display: none;
    }

    .search-input-row{
        margin-top: 10px;
    }
    .page{
        display: flex;
        justify-content: flex-end;
    }
    .total_page{
        margin-top: 16px;
        margin-right: 16px;
        color:#606266;
        font-size: 14px;
    }
    @media screen and (max-width: 1380px){
        .page{
            display: flex;
            justify-content: flex-end;
            margin-bottom:30px;
        }

        .summary span{
            font-size: 12px;
        }
    }
    @media screen and (max-width: 1440px) {
        #device-gantt{
            width: 103.6%;
        }
    }
    @media screen and (max-width: 1366px) {
        #device-gantt{
            width: 103.8%;
            height: 110%;
        }
        .content{
            padding-bottom: 40px
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 180px !important;
        }

        .scale-select{
            margin-left: 20px;
            width: 164px;
        }
        .explain .explain-item span{
        font-size: 12px;
        line-height:20px;
        }
        /* .explain .explain-item div {
            margin-top: 6px;
            width: 24px;
        } */
        .el-checkbox{
            margin-right: 20px;
        }
        .select-box{
            margin-left: 0px
        }
        .left-item{
            width: 190px;
        }
    }
    @media screen and (max-width: 1280px){
        #device-gantt{
            width: 104.2%;
        }
        .number-item {
            padding: 0 6px;
        }
        .number-item span{
            font-size: 26px
        }
        .hour{
            font-size: 14px;
            width: 28px;
        }
        .left-item{
            width: 170px;
        }
        .explain .explain-item{
            margin-right: 30px
        }
        .explain{
            margin-left:20px
        }
    }
</style>
<style>
.el-table  .el-table__body .rowbg{
    background:#ffffff !important;
}
.el-table  .el-table__body  .rowbg:hover>td{ background: #ffffff !important; }

.left-container {
    height: 640px;
}


 .select_width{
    width: 210px;
}
#device-gantt .el-tree >.el-tree-node{
    margin-bottom: 30px;
}
</style>





// WEBPACK FOOTER //
// src/views/gantt/deviceGantt.vue